<template>
  <div>
    <b-modal
      id="detail-employee-movement-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Pengajuan Mutasi Karyawan"
    >
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Karyawan</span></th>
                <td>{{ result.employee ? result.employee.fullName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Alasan Dipindah</span></th>
                <td>{{ result.note }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Cabang</span></th>
                <td>{{ result.branch ? result.branch.branchName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Departement</span></th>
                <td>
                  {{
                    result.jobTitle
                      ? result.jobTitle.department
                        ? result.jobTitle.department.departmentName
                        : "-"
                      : "-"
                  }}
                </td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Posisi</span></th>
                <td>
                  {{ result.jobTitle ? result.jobTitle.positionName : "-" }}
                </td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Band</span></th>
                <td>{{ result.band ? result.band.bandName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Grade</span></th>
                <td>{{ result.grade ? result.grade.gradeName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tanggal Penugasan</span></th>
                <td>{{ result.assignmentDate }}</td>
              </tr>
              
              <tr>
                <th><span class="font-weight-bold">Status</span></th>
                <td>{{ result.statusApproval }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>

     

    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow, BButton } from "bootstrap-vue";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
    BButton,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
};
</script>
